import React,{ useState, useEffect } from 'react'
import { Button, Col, Form, Row, Card, Select } from 'antd';
import Input from '../ui/Input';
import ActionButtonsBar from '../ui/ActionButtonsBar'
import Loading from "../Loading"
import { LocalPersistence, ApiCallsFactory } from "../../factories/index"
import { sessionType } from '../../interfaces/index'

const { Option } = Select;

interface propTypes {
  isEditable: () => void,
  cancelEditable:() => void, 
  disableTabPanes: (e: boolean) => void,
  setEditMode:(e: boolean) => void
  gdsName: string,
  editMode: boolean
}

const  GDSdata = (props: propTypes) => {

  const [ready, setReady] = useState<boolean>(false);
  const [gdsid, setgdsid] = useState('')
  const[isDeleteDisabled, setIsDeleteDisabled] = useState(false)

  const [ form ] = Form.useForm();

  const [ saveLock, setSaveLock] = useState(true)

  //Initial Load
  useEffect(() => {
    getDataFromStorage()
  },[])

  const getDataFromStorage = async () => {
    // getting data from the server
    const get_session = new LocalPersistence('session')
    const session: sessionType = await get_session.getSessionPersistence()
    const basicInfo = new ApiCallsFactory(`/property/gdsinfo?supplier=${session.supplier}&propertyid=${session.propertyId}`, session.token)
    const response: any =  await basicInfo.getData()

    if (response) {
      const { gds } = response?.property?.gdsinfo
    
      const data = gds.find((item: object | any) => item.name === props.gdsName)
        
      if (data) {
        initValues(data)
      } else {
        createGDSInfo()
      }
    }
  }

  const initValues = (data: object | any) => {
    setgdsid(data.gdsid)
    const initialValues = {
        chain: data.chain,
        hotelcode: data.hotelcode,
        shortname: data.shortname,
        longname: data.longname,
        bookable: data.bookable,
        roommasterhotelcode: data.roommasterhotelcode,
    }
    form.setFieldsValue(initialValues);
    setReady(true)
  }

  const handleDelete = async () =>{
    setIsDeleteDisabled(true);
      
    try {
      // getting session data
    
      const get_session = new LocalPersistence('session')
      const session: sessionType = await get_session.getSessionPersistence()
      const body = {
            "supplier": `${session.supplier}`,
            "propertyId": `${session.propertyId}`,
            "property":{
              "gdsinfo":{
                "gds":{
                  gdsid
                }
              }
           }
      }

      // post
      const basicInfoUpdated = new ApiCallsFactory(`/gdsinfo/gds`, session.token, body)
      await basicInfoUpdated.deleteData();
      
      
      createGDSInfo()

            
      } catch (error) {
          return error
      }


  }


    
  const createGDSInfo = async () => {
    
    try {
        // getting session data
        const get_session = new LocalPersistence('session')
        const session: sessionType = await get_session.getSessionPersistence()
        const body = {
              "supplier": `${session.supplier}`,
              "propertyId": `${session.propertyId}`,
              "property":{
                "gdsinfo":{
                  "gds":{
                      "name": props.gdsName,
                      "chain": "",
                      "hotelcode": "",
                      "shortname": "",
                      "longname": "",
                      "bookable": "",
                      "roommasterhotelcode": ""
                  }
                }
             }
        }
        // post
        const basicInfoUpdated = new ApiCallsFactory(`/gdsinfo/gds`, session.token, body)
        await basicInfoUpdated.postData()
        // getting data from the server
        const basicInfo = new ApiCallsFactory(`/property/gdsinfo?supplier=${session.supplier}&propertyid=${session.propertyId}`, session.token)
        const data: any =  await basicInfo.getData()
        // setting up the session persisting
        const sessionPersiting = new LocalPersistence('GDSinfo', data.property)
        await sessionPersiting.setSessionPersistence()
        // getting data from session persisting
        const localData = new LocalPersistence('GDSinfo')
        const response = await localData.getSessionPersistence()
        if (response.gdsinfo) {
            const { gds } = response.gdsinfo
            const data = gds.find((item: object | any) => item.name === props.gdsName)
            initValues(data)
        }
        setReady(true)
        props.disableTabPanes(false)
        props.setEditMode(false); 
        props.cancelEditable();
        } catch (error) {
            return error
        }
  }

  const saveData = async(value: object | any) => {
    setReady(false)
    try {
      // getting session data
      const get_session = new LocalPersistence('session')
      const session: sessionType = await get_session.getSessionPersistence()
      const body = {
        "supplier": `${session.supplier}`,
        "propertyId": `${session.propertyId}`,
        "property":{
                "gdsinfo":{
                    "gds":{
                        "gdsid": gdsid,
                        "name": props.gdsName,
                        "chain": value.chain,
                        "hotelcode": value.hotelcode,
                        "shortname": value.shortname,
                        "longname": value.longname,
                        "bookable": value.bookable,
                        "roommasterhotelcode": value.roommasterhotelcode
                    }
                }
            }
        }
      // post
        const basicInfoUpdated = new ApiCallsFactory(`/gdsinfo/gds`, session.token, body)
        await basicInfoUpdated.postData()
        // getting data from the server
        const basicInfo = new ApiCallsFactory(`/property/gdsinfo?supplier=${session.supplier}&propertyid=${session.propertyId}`, session.token)
        const data: any =  await basicInfo.getData()
        // setting up the session persisting
        const sessionPersiting = new LocalPersistence('GDSinfo', data.property)
        await sessionPersiting.setSessionPersistence()
        // getting data from session persisting
        const localData = new LocalPersistence('GDSinfo')
        const response = await localData.getSessionPersistence()
        if (response.gdsinfo) {
            const { gds } = response.gdsinfo
            const data = gds.find((item: object | any) => item.name === props.gdsName)
            initValues(data)
        }
        setReady(true)
        props.disableTabPanes(false)
        props.setEditMode(false);
        setIsDeleteDisabled(false) 
        props.cancelEditable();
        } catch (error) {
            return error
        }
  }

   const cancelEdit = () => {
      setReady(false)
      form.resetFields(); 
      getDataFromStorage();
      props.disableTabPanes(false)
      props.setEditMode(false); 
      setSaveLock(true)
      props.cancelEditable();
   }

   const saveEdit = () => {
    form.validateFields().then(async (value) => {
      setReady(false)
      saveData(value)
    })
   }
   const onFieldsChange = (changedFields: any, allFields: any) => {
    const s = form.getFieldsError()
    let savelock = false
    for (let i = 0; i < s.length; i++) {
       if(s[i].errors.length) {
          savelock = true;
         break
       }
    }
    setSaveLock(savelock)
  }

  if (!ready) return (<Loading type="large" />)
  return (
    <Card style={{ marginTop: '-15px' }}>
      <div className='col-12'>
        <Form
          layout='vertical'
          form={form}
          name='basic'
          onFinish={() => {}}
          onFinishFailed={() => {}}
          onFieldsChange={onFieldsChange}
          onValuesChange={() => {}}>
          <Row gutter={24}>
            <Col span={9}>
              <Form.Item
                label='Chain'
                name='chain'
                rules={[
                  {
                    max: 2,
                    message: 'You have reached the max character length of 2',
                  },
                ]}>
                <Input
                  maxLength={2}
                  edit={props.editMode}
                  className={props.editMode ? '' : 'lock'}
                />
              </Form.Item>
            </Col>

            { props.gdsName !== 'Galileo' &&
              <Col span={9}>
                <Form.Item
                  label='Hotel Code'
                  name='hotelcode'
                  rules={[
                    {
                      max: 128,
                      message: 'You have reached the max character length of 128',
                    },
                  ]}>
                  <Input
                    maxLength={128}
                    edit={props.editMode}
                    className={props.editMode ? '' : 'lock'}
                  />
                </Form.Item>
              </Col>
            }
          </Row>
          {
            props.gdsName === 'Galileo' &&
            <Row gutter={24}>
              <Col span={9}>
                <Form.Item
                  label='Apollo/Galileo Hotel Code'
                  name='hotelcode'
                  rules={[
                    {
                      max: 128,
                      message: 'You have reached the max character length of 128',
                    },
                  ]}>
                  <Input
                    maxLength={128}
                    edit={props.editMode}
                    className={props.editMode ? '' : 'lock'}
                  />
                </Form.Item>
              </Col>
              <Col span={9}>
                <Form.Item
                  label='RoomMaster Hotel Code'
                  name='roommasterhotelcode'
                  rules={[
                    {
                      max: 128,
                      message: 'You have reached the max character length of 128',
                    },
                  ]}>
                  <Input
                    maxLength={128}
                    edit={props.editMode}
                    className={props.editMode ? '' : 'lock'}
                  />
                </Form.Item>
              </Col>
            </Row>
          }
          <Row gutter={24}>
            <Col span={9}>
              <Form.Item
                label='Property Name(Short)'
                name='shortname'
                rules={[
                  {
                    max: 64,
                    message: 'You have reached the max character length of 64',
                  },
                ]}>
                <Input
                  maxLength={64}
                  edit={props.editMode}
                  className={props.editMode ? '' : 'lock'}
                />
              </Form.Item>
            </Col>

            <Col span={9}>
              <Form.Item
                label='Property Name(Long)'
                name='longname'
                rules={[
                  {
                    max: 128,
                    message: 'You have reached the max character length of 128',
                  },
                ]}>
                <Input
                  maxLength={128}
                  edit={props.editMode}
                  className={props.editMode ? '' : 'lock'}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={9}>
              <Form.Item label='Bookable' name='bookable'>
                <Select allowClear className={props.editMode ? '' : 'lock'} showSearch>
                  <Option value='yes'>Yes</Option>
                  <Option value='no'>No</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
      <ActionButtonsBar
        onCancel={cancelEdit}
        onDelete={handleDelete}
        disabledDelete={isDeleteDisabled}
        onSave={saveEdit}
        disabledSave={saveLock}
        show={props.editMode}
      />
    </Card>
  )
}

export default GDSdata
